import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Platforms from "./components/Platforms";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Pricing from "./components/Pricing";
import Referral from "./components/Referral";
import Security from "./components/Security";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Waitlist from "./components/Waitlist";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";
import AdminLogin from "./components/AdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "sonner";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookiePolicy from "./components/CookiePolicy";
import ContactUs from "./components/ContactUs";
import ScrollToTop from "./components/ScrollToTop";
import Download from "./components/Download";

const Home = () => {

  useEffect(() => {
  const hash = window.location.hash;

  if (hash) {
    const section = document.querySelector(hash);

    if (section) {
      setTimeout(() => {
        section.scrollIntoView({
          behavior: "smooth",
        });
      }, 100);
    }
  }
}, []);
  
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Platforms />
      <Features />
      <HowItWorks />
      <Pricing />
      <Referral />
      <Security />
      <Testimonials />
      <FAQ />
      <Waitlist />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/download" element={<><Header /><Download /><Footer /></>} />
            <Route path="/download.html" element={<><Header /><Download /><Footer /></>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="/privacy-policy" element={ <>
        <PrivacyPolicy />
        <Footer />
      </>} />

      <Route
  path="/terms-of-service"
  element={
    <>
      <TermsOfService />
      <Footer />
    </>
  }
/>

<Route
  path="/cookie-policy"
  element={
    <>
      <CookiePolicy />
      <Footer />
    </>
  }
/>

<Route
  path="/contact-us"
  element={
    <>
      <ContactUs />
      <Footer />
    </>
  }
/>

          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
